import React from "react";
import Email from "@material-ui/icons/Email";
import EmailOutlined from "@material-ui/icons/EmailOutlined";
import { Field, InfoPanel, StepHeader } from "./ui";

export default function Start({
  application,
  errors,
  onApplicationTextChange
}) {
  const props = { application, errors, onApplicationTextChange };
  return (
    <div className="merchant-start">
      <StepHeader title="Let's Get Started">
        This application takes about 5 minutes to complete.
      </StepHeader>
      <div className="merchant-email-info">
        <InfoPanel title="Email Address" icon={Email} featured>
          This email will be used for your merchant statements, important
          account updates, and logging in to your point of sale. You can use
          either a personal or business email address.
        </InfoPanel>
      </div>
      <div className="merchant-grid">
        <Field
          {...props}
          name="email"
          label="Email Address"
          icon={EmailOutlined}
          required
          inputProps={{ inputMode: "email" }}
          autoComplete="email"
        />
        <Field
          {...props}
          name="confirmEmail"
          label="Confirm Email Address"
          icon={EmailOutlined}
          required
          inputProps={{ inputMode: "email" }}
          autoComplete="off"
        />
      </div>
    </div>
  );
}
